import { defineBalloonManager, defineHotspotsLayer, definePinsLayer } from './mapModules';

export const defineOwnYandexModulesAndLayers = async (
  ymaps: YMaps.IYMaps,
  modules: string[] = [],
): Promise<YMaps.IYMaps> => {
  definePinsLayer(ymaps);
  defineHotspotsLayer(ymaps);
  defineBalloonManager(ymaps);

  await ymaps.ready({
    require: modules,
  });

  return ymaps;
};
